import type { MarketplaceWallet, PlayerWallet } from '@svs/nova-poolbetting/ui/CouponAdditions';

import type { InjectedWalletProps } from '@/components/context/withContextWallet';

/**
 * This function combines the player's main wallet with any activated draw wallets into a single array of wallets that can be used in the coupon additions feature.
 *
 * @param playerWalletBalance the balance of the player's main wallet
 * @param activatedDraws an array of activated draws, each containing balance, activatedDrawId, and GroupName
 * @returns an array of wallets including the player's main wallet and any activated draw wallets, formatted for use in the coupon additions feature
 */
export function getWalletsData(
  playerWalletBalance?: number,
  activatedDraws?: InjectedWalletProps['contextWallets']
): (PlayerWallet | MarketplaceWallet)[] {
  if (playerWalletBalance === undefined || !activatedDraws) {
    return [];
  }
  const wallets: (PlayerWallet | MarketplaceWallet)[] = [
    {
      type: 'WALLET_PLAYER',
      balance: playerWalletBalance,
      name: 'Min spelkassa',
    },
  ];
  for (const activatedDraw of activatedDraws) {
    wallets.push({
      type: 'WALLET_MARKETPLACE_PLAYER',
      balance: activatedDraw.balance,
      activatedDrawId: activatedDraw.activatedDrawId,
      name: activatedDraw.name,
    });
  }
  return wallets;
}
